export default __webpack_public_path__ + "static/media/goods5.e2a5d451.gif";